<script>
import moment from 'moment';
import API from '../services/api';
import Vuex from 'vuex';

const api = new API();

module.exports = {
  template: '#cars-template',
  data: function() {
    return {
      activeStore: false,
      path: this.$route.path,
      historyEventShow: [],
      serviceContractsShow: [],
      carTradeEstimate: [],
      carContactPersons: [],
      carKm: [],
      removeCars: [],
      fiksudiilifaq: [],
      currentOpen: [],
      isCurrentCarFD: false,
      isActive: false,
      openFDByDefault: true,
      openBIByDefault: true,
    };
  },
  methods: {
    updateCarKm: function(license, driven) {
      api
        .updateCarKMs({
          license: license,
          driven: driven,
        })
        .then(res => {})
        .catch(error => {
          //console.log(error.statusText);
        });

      this.toggleCarKm(license);
    },
    toggleRemoveCar: function(license) {
      if (this.removeCars.indexOf(license) >= 0) {
        this.removeCars.splice(this.removeCars.indexOf(license), 1);
      } else this.removeCars.push(license);
    },
    removeCar: function(license) {
      api
        .removeCar({
          license: license,
        })
        .then(res => {
          this.$store.state.cars.active = this.$store.state.cars.active.reduce((result, car) => {
            if (car.license != license) result.push(car);
            return result;
          }, []);
          this.$router.push({ name: 'cars' });
        })
        .catch(error => {
          //console.log(error.statusText);
        });
    },
    getEstimate: function(event, license, driven) {
      event.target.classList.add('disabled');
      this.$store.state.cars.active = this.$store.state.cars.active.map(car => {
        if (car.license == license) {
          car.estimate = false;
        }

        return car;
      });

      dataLayer.push({
        event: 'GAEvent',
        eventCategory: 'OmaLaakkonen',
        eventAction: 'CarExchangeOffer',
        eventLabel: '',
        eventNonInteraction: 'false',
      });

      api
        .updateCarTradeEstimate({
          license: license,
          driven: driven,
        })
        .then(res => {
          // Estimate succesfully created
          this.carsLoaded = true;
          this.$store.state.cars.active = this.$store.state.cars.active.map(car => {
            if (car.license == license) {

              if (res.estimate) {
                car.estimate = res.estimate;
                car.estimate_asked = res.estimate.asked;
                car.update_estimate_date = res.update_estimate_date;
                car.estimate_ask_allowed = res.estimate_ask_allowed;
                car.local_estimate_asked_text = res.local_estimate_asked_text;
                car.store_estimate_asked_text = res.store_estimate_asked_text;
                car.storeEstimateAsked = res.storeEstimateAsked;
              } else {
                car.error_message = res.msg ? res.msg : res.error;
              }
            }
            this.toggleCarTradeEstimate(license);
            event.target.classList.remove('disabled');
            return car;
          });
        })
        .catch(error => {
          //console.log(JSON.stringify(error));
        });
    },
    toggleFiksudiiliFaq: function() {
      this.fiksudiilifaq = this.$store.state.fiksudiilifaq;
    },
    toggleCarTradeEstimate: function(license) {
      if (this.carTradeEstimate.indexOf(license) >= 0) this.carTradeEstimate.splice(this.carTradeEstimate.indexOf(license), 1);
      else this.carTradeEstimate.push(license);
    },
    toggleCarContactPersons: function(license) {
      if (this.carContactPersons.indexOf(license) >= 0) this.carContactPersons.splice(this.carContactPersons.indexOf(license), 1);
      else this.carContactPersons.push(license);
    },
    toggleCarKm: function(license) {
      if (this.carKm.indexOf(license) >= 0) this.carKm.splice(this.carKm.indexOf(license), 1);
      else this.carKm.push(license);
    },
    toggleHistoryBlock: function(invoiceNumber) {
      /*if (this.historyEventShow.indexOf(invoiceNumber) >= 0) this.historyEventShow.splice(this.historyEventShow.indexOf(invoiceNumber), 1);
      else*/

      if (this.historyEventShow.indexOf(invoiceNumber) >= 0) this.historyEventShow = [];
      else {
        this.historyEventShow = [];
        this.historyEventShow.push(invoiceNumber);
      }
    },
    toggleServiceBlock: function(name) {
      if (this.serviceContractsShow.indexOf(name) >= 0) this.serviceContractsShow.splice(this.serviceContractsShow.indexOf(name), 1);
      else this.serviceContractsShow.push(name);
    },
    toggleClasses: function(license, current) {
      var element_to_scroll_to = document.getElementById(current);
      element_to_scroll_to.scrollIntoView();
      this.currentOpen.length = 0;
      this.openFDByDefault = false;
      this.openBIByDefault = false;

      if (this.currentOpen.indexOf(current) == 0) {
        //pushing a nonsense value to array will properly reset the open class in vue, leaving it empty will not
        this.currentOpen.push('none');
      } else {
        this.currentOpen.push(current);
      }
    },
    thisQuestion: function(i) {
      var thiselement = document.querySelector('[name="' + i + '"]');
      if (thiselement.classList.contains('open')) {
        thiselement.classList.remove('open');
      } else {
        thiselement.classList.add('open');
      }
    },
    changeCarWithLicense(license) {
      this.$router.push({ path: '/omat-autot/' + license });
      this.$store.state.cars.current = license;
    },
    changeCar(event) {
      this.$router.push({ path: '/omat-autot/' + event.target.value });
      this.$store.state.cars.current = event.target.value;
    },
    changeStore(event) {
      let cars = this.$store.state.cars;

      for (let i = 0; i < cars.active.length; i++) {
        let car = cars.active[i];

        for (let j = 0; j < car.contact_info.stores.length; j++) {
          let store = car.contact_info.stores[j];

          if (store.dealer_id == event.target.value) this.activeStore = store;
        }
      }
    },
  },
  computed: {
    active: function() {
      // license is fetched from the url. If the url doesn't have a license defined, we will use the default defined in index.js (current)
      // current changes every time user changes a car
      let license = typeof this.$route.params.license !== 'undefined' ? this.$route.params.license : this.$store.state.cars.current;
      if (!license && this.$store.state.cars.active.length > 0) {
        return this.$store.state.cars.active[0].license;
      }
      let activeCars = this.$store.state.cars.active;
      for (let car of activeCars) {
        if (car.license == license && car.fiksudiili == true) {
          this.isCurrentCarFD = true;
          break;
        } else {
          this.isCurrentCarFD = false;
        }
      }
      return license;
    },
    cars: function() {
      let cars = this.$store.state.cars;
      let brands = this.$store.state.brands;
      let brandPhonenumbers = this.$store.state.brandPhonenumbers ? this.$store.state.brandPhonenumbers : [];
      this.toggleFiksudiiliFaq();
      cars.active = cars.active.map(car => {
        car.previous_maintenance_date = car.maintenances.length ? car.maintenances[0].date + 'Z' : '-';
        car.maintenance_store_image = '';

        if (car.contact_info) {
          if (car.contact_info.stores && car.contact_info.stores.length > 0) {
            car.maintenance_store_image =
              car.contact_info.stores.length > 0
                ? car.contact_info.stores.reduce((result, store) => {
                    if (store.selected) {
                      result = store.image;
                      this.activeStore = store;
                    }

                    return result;
                  }, '')
                : '';
          } else
            car.contact_info = {
              stores: false,
              persons: [],
            };
        }

        return car;
      });

      return cars;
    },
  },
  watch: {
    active: function(val) {
      let activeCars = this.$store.state.cars.active;
      if (activeCars.length > 0) {
        for (let car of activeCars) {
          if (car.license == val && car.fiksudiili == true) {
            this.currentOpen.length = 0;
            this.currentOpen.push('fiksudiiliInfo');
            break;
          } else {
            this.currentOpen.length = 0;
            this.currentOpen.push('carBasicInfo');
          }
        }
      }
    },
  },
};
</script>
